import { useState } from "react";
import { toast } from "sonner";
import { Loader2, PenLine } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { FirmaPad } from "@/components/contratos/FirmaPad";

export function FirmaCertForm({ v, onFirmar }) {
  const [d, setD] = useState({ nombre: v.cliente_nombre || "", dni: "", firma: "", acepto: false });
  const [busy, setBusy] = useState(false);
  const firmar = async () => {
    if (d.nombre.trim().length < 2) return toast.error("Escribe tu nombre y apellidos");
    if (d.dni.trim().length < 5) return toast.error("Escribe tu DNI, NIE o NIF");
    if (!d.firma) return toast.error("Firma en el recuadro");
    if (!d.acepto) return toast.error("Marca la casilla para confirmar que estás conforme");
    setBusy(true);
    try { await onFirmar({ ...d, huella: v.huella }); }
    finally { setBusy(false); }
  };
  return (
    <section className="space-y-4 rounded-2xl border-2 border-[#00B4CC]/40 bg-white p-4 sm:p-6" data-testid="cert-firma-form">
      <h2 className="flex items-center gap-2 font-bold text-[#1B2B4B]"><PenLine className="w-5 h-5 text-[#00B4CC]" /> Firma la certificación</h2>
      <div className="grid gap-3 sm:grid-cols-2">
        <div><Label className="text-xs">Nombre y apellidos</Label><Input value={d.nombre} onChange={(e) => setD({ ...d, nombre: e.target.value })} className="mt-1" data-testid="cert-firma-nombre" /></div>
        <div><Label className="text-xs">DNI / NIE / NIF</Label><Input value={d.dni} onChange={(e) => setD({ ...d, dni: e.target.value })} className="mt-1" data-testid="cert-firma-dni" /></div>
      </div>
      <FirmaPad onChange={(firma) => setD((x) => ({ ...x, firma }))} testid="cert-firma-pad" />
      <label className="flex items-start gap-2.5 text-sm text-slate-700">
        <input type="checkbox" checked={d.acepto} onChange={(e) => setD({ ...d, acepto: e.target.checked })} className="mt-1" data-testid="cert-firma-acepto" />
        He revisado la certificación y estoy conforme con el avance y los importes certificados.
      </label>
      <Button onClick={firmar} disabled={busy} className="h-12 w-full rounded-xl bg-[#1B2B4B] font-bold text-white hover:bg-[#13203A]" data-testid="cert-firma-enviar">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Firmar certificación"}
      </Button>
      <p className="text-[11px] text-slate-400">Al firmar se guardan la fecha y la hora, tu dirección IP y la huella digital del documento como prueba de la firma.</p>
    </section>
  );
}
